













import {Component, Ref, Vue, Watch, Prop, Emit} from 'vue-property-decorator';
import BButton from 'buefy/src/components/button/Button.vue';
import {namespace} from 'vuex-class';
import {MAFUser} from '@/store/User/types';
import {DateTime} from 'luxon';
// @ts-ignore
import * as firebase from 'firebase/app';
import QuerySnapshot = firebase.firestore.QuerySnapshot;
import QueryDocumentSnapshot = firebase.firestore.QueryDocumentSnapshot;

/* tslint:disable:no-console */
/* tslint:disable:no-empty */

const userNamespace = namespace('userState');
const friendNamespace = namespace('friendState');
const rateNamespace = namespace('rateState');

@Component({
  components: {
    BButton,
  },
})

export default class BlockUserModal extends Vue {
  @Prop() public readonly friend!: MAFUser;

  @userNamespace.State('self') public self!: MAFUser;
  @friendNamespace.State('friends') public friends!: MAFUser[];
  @userNamespace.Action('setUserBlock') public setUserBlock: any;

  public isBlocked: boolean = false;

  public mounted() {
    if (this.self.blocked && this.self.blocked.includes(this.friend.uid || '')) {
      this.isBlocked = true;
    }
  }

  public async blockUser() {
    // get friend with Reference
    const friendRef = this.friends.find((f) => f.uid === this.friend.uid);

    // block friend
    const params = { isBlocked: this.isBlocked, user: this.self, friend: friendRef};
    await this.setUserBlock(params);
    this.closeBlockModal();
  }

  @Emit('closeBlock')
  public closeBlockModal() {}
}
